/* eslint-disable prettier/prettier */

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import { Button, Card, Divider, Grid, Icon } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import {
  InformacionAllCitas,
  InformacionCitasProximas,
  InformacionCitasAnteriores,
  AgregarCita,
  AgregarDocumentoCita,
  NotificarPacienteCita,
  NotificarMedicoCita,
  EliminarCita,
} from "store/tav/tavActions";
import { InformacionInicialCatalogos } from "store/catalogos/catalogosActions";
import { useEffect, useMemo, useState } from "react";
import TableDataProx from "./data/DataTableCitasTav";
import { find } from "lodash";
import { getSolicitudesT } from "store/solicitudes/solicitudesActions";
import FormBusqueda from "./form/formBusqueda";
import FormNuevaCita from "./form/formNuevaCita";
import FormCargarDocumento from "./form/formCargarDocumento";
import Loading from "components/loading";
import ModalContent from "components/ModalContent";
import moment from "moment";
import "moment/locale/es"; // Importa el locale en español
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { store } from "store/store";

function Tav() {
  const usuario = store.getState().login.usuario;
  const route = useLocation().pathname.split("/").slice(1);
  const navigate = useNavigate();
  const {
    citas,
    citasProximas,
    isloadingCitasProximas,
    citasAnteriores,
    isloadingCitasAnteriores,
  } = useSelector((state) => state.tav);
  const { estudiosMedicos } = useSelector((state) => state.catalogos);

  const dispatch = useDispatch();

  useEffect(() => {
    InformacionAllCitas(dispatch);
    InformacionInicialCatalogos(dispatch);
    getSolicitudesT(dispatch, { esExpediente: true });
  }, []);

  useEffect(() => {
    if (estudiosMedicos.length > 0) {
      const tav = find(estudiosMedicos, { descripcion: "TAV" })?.idEstudio || 63;

      InformacionCitasProximas(dispatch, tav, 0);
      InformacionCitasAnteriores(dispatch, tav, 0);
    }
  }, [estudiosMedicos]);

  //Form nueva cita
  const [fechaCita, setFechaCita] = useState("");
  const [horaCita, setHoraCita] = useState(0);
  const [observaciones, setObservaciones] = useState(" ");
  const [idSolicitud, setIdSolicitud] = useState(0);
  const [idMedico, setIdMedico] = useState(null);

  //Form cargar documento
  const [idSolicitudCitaDoc, setIdSolicitudCitaDoc] = useState(null);
  const [idCita, setIdCita] = useState(null);
  const [tituloDoc, setTituloDoc] = useState("");
  const [documento, setDocumento] = useState(null);
  const [observacionesDoc, setObservacionesDoc] = useState(" ");

  const [rowSelect, setRowSelect] = useState({});

  const [openmodal, setopenmodal] = useState(false);
  const [openmodalDelete, setopenmodalDelete] = useState(false);
  const [openmodalCargarDoc, setOpenmodalCargarDoc] = useState(false);
  const [openmodalNotiP, setOpenmodalNotiP] = useState(false);
  const [openmodalNotiM, setOpenmodalNotiM] = useState(false);

  const refresh = () => {
    setFechaCita("");
    setHoraCita("");
    setObservaciones("");
    setIdMedico("");
    setopenmodal(false);
  };

  const refreshDoc = () => {
    setIdSolicitudCitaDoc(null);
    setIdCita(null);
    setTituloDoc("");
    setDocumento(null);
    setObservacionesDoc("");
    setOpenmodalCargarDoc(false);
  };

  const save = () => {
    const [hora, minuto] = horaCita.split(":").map(Number);

    var nuevaCita = {
      idEstudio: find(estudiosMedicos, { descripcion: "TAV" })?.idEstudio || 63,
      fechaCita: fechaCita,
      horaCita: hora,
      minutoCita: minuto,
      idHospital: 11,
      idMedico: idMedico,
      observaciones: observaciones,
      idSolicitud: idSolicitud,
      precio: 0,
    };

    //Buscar si ya existe una cita en la misma fecha, hora y minuto
    // que coincida por solicitud o por médico
    const conflicto = citas.find((cita) => {
      const mismaFecha = moment(cita.fechaCita).isSame(nuevaCita.fechaCita, "day");
      const mismaHora = cita.horaCita === nuevaCita.horaCita;
      const mismoMinuto = cita.minutoCita === nuevaCita.minutoCita;

      const coincideFechaHora = mismaFecha && mismaHora && mismoMinuto;

      // a) Conflicto por la misma solicitud (idSolicitud) en esa fecha/hora
      if (coincideFechaHora && cita.idSolicitud === nuevaCita.idSolicitud) {
        toast.error("Ya existe una cita registrada para este paciente en esa fecha y hora.");
        return true;
      }

      // b) Conflicto por el mismo médico (idMedico) en esa fecha/hora
      if (coincideFechaHora && cita.idMedico === nuevaCita.idMedico) {
        toast.error("Este médico ya tiene una cita registrada en esa fecha y hora.");
        return true;
      }

      return false; // No hay conflicto
    });

    // Si hay conflicto, salir de la función
    if (conflicto) return;

    // Si no hay conflictos, guardar la cita
    AgregarCita(dispatch, nuevaCita, true);
    setopenmodal(false);
    refresh();
  };

  const handleEliminarCita = async () => {
    const exito = await dispatch(
      EliminarCita({ idCita: rowSelect.idCita, idSolicitud: rowSelect.idSolicitud }, true)
    );
    setopenmodalDelete(!exito);
  };

  const saveDoc = () => {
    var datosCita = {
      IdSolicitud: idSolicitudCitaDoc,
      IdCita: idCita,
      IdUsuarioCarga: usuario.idUsuario,
      Observaciones: observacionesDoc,
      TituloDocumento: tituloDoc,
      Estudio: "TAV",
      UserName: usuario.username,
      Archivo: documento,
    };

    // cargar el archivo
    AgregarDocumentoCita(dispatch, datosCita, true);
    setOpenmodalCargarDoc(false);
    refreshDoc();
  };

  const columnsCitas = useMemo(() => {
    if (!estudiosMedicos || estudiosMedicos.length === 0) return []; // evita renderizar columnas si no hay datos
    return [
      {
        header: "Fecha",
        size: 185,
        Cell: ({ row }) => {
          return moment(
            row.original.fechaCita.split("T")[0] +
              `T${String(row.original.horaCita).padStart(2, "0")}:${String(
                row.original.minutoCita
              ).padStart(2, "0")}:00`
          ).format("dddd D [de] MMMM [de] YYYY");
        },
      },
      {
        accessorKey: "horaCompleta",
        header: "Hora",
        size: 90,
        Cell: ({ row }) => {
          return `${String(row.original.horaCita).padStart(2, "0")}:${String(
            row.original.minutoCita
          ).padStart(2, "0")} Hrs`;
        },
      },
      {
        accessorKey: "paciente",
        header: "Paciente",
        size: 200,
        Cell: ({ row }) => {
          return `${row.original.nombreCandidato} ${row.original.aPaternoCandidato} ${row.original.aMaternoCandidato}`;
        },
      },
      {
        accessorKey: "estudio",
        header: "Estudio",
        size: 40,
        Cell: ({ row }) => {
          return find(estudiosMedicos, { idEstudio: row.original.idEstudio })?.descripcion || "";
        },
      },
      {
        accessorKey: "hospital",
        header: "Lugar",
        size: 130,
      },
      {
        accessorKey: "medico",
        header: "Médico",
        size: 130,
        Cell: ({ row }) => {
          return `${row.original.nombreMedico} ${row.original.apellidoPaternoMedico}`;
        },
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
        size: 150,
      },
    ];
  }, [estudiosMedicos]);

  moment.locale("es");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Gestión de citas
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right">
                      <Button
                        variant="contained"
                        startIcon={<Icon>calendar_month</Icon>}
                        color="primary"
                        size="small"
                        style={{ textTransform: "inherit", background: "#1D1D1B" }}
                        onClick={() => {
                          navigate("/calendarioCitas", {
                            state: {
                              citas: [...citasAnteriores, ...citasProximas],
                              ruta: "/" + route,
                            },
                          });
                        }}
                      >
                        Calendario de citas
                      </Button>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox textAlign="center" mt={3} ml={2} mr={2}>
                <FormBusqueda
                  onSearch={(filtros) => {
                    setIdSolicitud(filtros.idSolicitud);
                  }}
                  onClickNueva={() => {
                    setopenmodal(true);
                  }}
                ></FormBusqueda>
              </MDBox>
              <Divider />
              <MDBox pt={3}>
                {isloadingCitasProximas || estudiosMedicos.length === 0 ? (
                  <Loading title={"Cargando citas proximas, por favor espere."} />
                ) : citasProximas.length === 0 ? (
                  <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
                    NO HAY CITAS PRÓXIMAS PARA MOSTRAR
                  </MDTypography>
                ) : (
                  <TableDataProx
                    columns={columnsCitas}
                    data={citasProximas}
                    tablaProx={true}
                    EliminarCita={(dataCita) => {
                      setRowSelect(dataCita);
                      setopenmodalDelete(true);
                    }}
                    NotificarPaciente={(dataCita) => {
                      setRowSelect(dataCita);
                      setOpenmodalNotiP(true);
                    }}
                    NotificarMedico={(dataCita) => {
                      setRowSelect(dataCita);
                      setOpenmodalNotiM(true);
                    }}
                  />
                )}
              </MDBox>
              <Divider />
              <MDBox pt={3}>
                {isloadingCitasAnteriores || estudiosMedicos.length === 0 ? (
                  <Loading title={"Cargando citas anteriores, por favor espere."} />
                ) : citasAnteriores.length === 0 ? (
                  <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
                    NO HAY CITAS ATERIORES PARA MOSTRAR
                  </MDTypography>
                ) : (
                  <TableDataProx
                    columns={columnsCitas}
                    data={citasAnteriores}
                    tablaProx={false}
                    onCargarDoc={(row) => {
                      setIdSolicitudCitaDoc(row.idSolicitud);
                      setIdCita(row.idCita);
                      setOpenmodalCargarDoc(true);
                    }}
                  />
                )}
                <Divider />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ModalContent
        title={"Agregar Cita Aurea Lab"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodal}
        fullScreen={false}
        handleClose={refresh}
        handleAcept={save}
        textAccept="Agregar cita"
      >
        <FormNuevaCita
          props={{
            fechaCita: fechaCita,
            horaCita: horaCita,
            observaciones: observaciones,
            idSolicitud: idSolicitud,
            idMedico: idMedico,
          }}
          onChangeCita={(value, campo) => {
            if (campo === "fechaCita") setFechaCita(value);
            if (campo === "horaCita") setHoraCita(value);
            if (campo === "observaciones") setObservaciones(value);
            if (campo === "idSolicitud") setIdSolicitud(value);
            if (campo === "idMedico") setIdMedico(value);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Eliminar cita"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalDelete}
        fullScreen={false}
        handleClose={() => {
          setopenmodalDelete(false);
        }}
        handleAcept={() => {
          handleEliminarCita();
        }}
        textAccept={"Eliminar"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea eliminar la cita del paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <ModalContent
        title={"Cargar valoración a la cita"}
        maxWidth="sm"
        fullWidth={true}
        open={openmodalCargarDoc}
        fullScreen={false}
        handleClose={refreshDoc}
        handleAcept={saveDoc}
        textAccept="Cargar valoración"
      >
        <FormCargarDocumento
          props={{
            tituloDoc: tituloDoc,
            documento: documento,
            observacionesDoc: observacionesDoc,
          }}
          onChangeDoc={(value, campo) => {
            if (campo === "tituloDoc") setTituloDoc(value);
            if (campo === "documento") setDocumento(value);
            if (campo === "observaciones") setObservacionesDoc(value);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Notificar Paciente"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalNotiP}
        fullScreen={false}
        handleClose={() => {
          setOpenmodalNotiP(false);
        }}
        handleAcept={() => {
          NotificarPacienteCita(rowSelect.idSolicitud);
          setOpenmodalNotiP(false);
        }}
        textAccept={"Notificar paciente"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea notificar al paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>{" "}
            sobre su cita con el médico{" "}
            <strong>
              {rowSelect.nombreMedico} {rowSelect.apellidoPaternoMedico}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <ModalContent
        title={"Notificar Médico"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalNotiM}
        fullScreen={false}
        handleClose={() => {
          setOpenmodalNotiM(false);
        }}
        handleAcept={() => {
          var data = {
            idSolicitud: rowSelect.idSolicitud,
            fechaCliente: moment().format("YYYY-MM-DD"),
          };
          NotificarMedicoCita(data);
          setOpenmodalNotiM(false);
        }}
        textAccept={"Notificar médico"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea notificar al médico{" "}
            <strong>
              {rowSelect.nombreMedico} {rowSelect.apellidoPaternoMedico}
            </strong>{" "}
            sobre su cita con el paciente{" "}
            <strong>
              {rowSelect.nombreCandidato} {rowSelect.aPaternoCandidato}{" "}
              {rowSelect.aMaternoCandidato}
            </strong>
            ?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <Footer />
    </DashboardLayout>
  );
}

export default Tav;
